import axios from 'axios';

// const API_ENDPOINT = 'https://prod-111.westeurope.logic.azure.com:443/workflows/9671f6bb11df475598c4d20876056e09/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=3-mXXb-GQb4-uFxl1auw7VbSeaHkbEx4N-tePZZEuuY'
const API_ENDPOINT = 'https://prod-244.westeurope.logic.azure.com:443/workflows/38944d37488c498e98ab5f09650dee62/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=KWRChjT-XeNOciG27Aecs8KaY7v5U_nWiKx5qR593dY'

export function submitRequest({ photo, ...rest }) {
  const formData = new FormData();
  const payload = {
    ...rest
  };


  formData.append(
    'information',
    new Blob(
      [
        JSON.stringify(payload)
      ],
      { type: 'application/json'
      })
  )

  photo.forEach((file, index) => {
    formData.append(`photo${[index]}`, file.originFileObj, file.name);
  });

  return axios.post(API_ENDPOINT, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
